import { render, staticRenderFns } from "./Addstudent.vue?vue&type=template&id=0982b708&scoped=true"
import script from "./Addstudent.vue?vue&type=script&lang=js"
export * from "./Addstudent.vue?vue&type=script&lang=js"
import style0 from "./Addstudent.vue?vue&type=style&index=0&id=0982b708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982b708",
  null
  
)

export default component.exports